import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import PageHeader from "../../components/PageHeader";
import Layout from "../../components/Layout";
import EmptyPropertyCard from "./components/EmptyListingCard";
import { getPMListings, getListings } from "../../services/listings";
import ListingCard from "./ListingCard";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { IdentityContext } from "@react-beets/identity";
import PropertyManager from "../AppHome/PropertyManager";

const LISTING_TYPE = {
  propertyManager: "1",
  tenant: "2",
}

function PrivateListingsPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [listings, setListings] = useState([]);
  const [listingType, setListingType] = React.useState('1');
  const isPropertyManager =
  localStorage.getItem("userType") === "propertymanager" || false;
  const { identity } = useContext(IdentityContext);
  
  /**
   * TenantView - Tenant - getListings - NoFilter / getListings
  * PMView - tenant (Tenant Listings) - authorId != loggedInUserId* / getPMListings
   * PMView - propertyManager (MyListings) - getListings - NoFilter / getListings
   */
  
  useEffect(() => {
    setIsLoading(true);
    const loadListings = async () => {
      let data = [];
      try {
        if (isPropertyManager) {
          if (listingType == LISTING_TYPE.tenant) {
            data = await getPMListings();
            data = data.filter((listing) => listing?.authorUserId !== identity?.profile?.sub);
          } else {
            data = await getListings();
          }
        } else {
          data = await getListings();
        }
        setListings(data);
      } catch (e) {
        console.error("Erroor occured while loading the listings", e);
      } finally {
        setIsLoading(false);
      }
    }
    loadListings();
  }, [listingType]);

  const handleChange = (event, listingType) => {
    setListingType(listingType);
  };

  const ListGrid = (props) => {
    const { listings } = props;
    return (
      <Grid container columnSpacing={{ xs: 0, sm: 2 }}>
        {listings?.length> 0 && listings?.map((listing, index) => {
          return (
            <Grid key={index} item xs={12} sm={6} md={3}>
              <ListingCard listing={listing} />
            </Grid>
          );
        })}
        {!listings?.length && <EmptyPropertyCard />}
      </Grid>
    );
  }


  return (
    <Layout isLoading={isLoading}>
      {/* <PageHeader title="Listings" />         */}
      {isPropertyManager &&  <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={listingType}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="My Listings" value="1" />
              <Tab label="Tenant Listings" value="2" />
            </TabList>
          </Box>
          <TabPanel value={LISTING_TYPE.propertyManager}>
            <ListGrid listings={listings}></ListGrid>
          </TabPanel>
          <TabPanel value={LISTING_TYPE.tenant}>
            <ListGrid listings={listings}></ListGrid>
          </TabPanel>
        </TabContext>
      </Box>}
      {!isPropertyManager &&  <ListGrid listings={listings}></ListGrid>}      
    </Layout>
  );
}

export default PrivateListingsPage;
